import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyles from 'assets/styles/default.scss';

export const useContainerStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      container: {
        padding: '4px 0',
      },
      button: {
        borderRadius: 4,
        backgroundColor: '#F8F9F7',
      },
      nome: {
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis', 
      },
    }),
  {
    name: 'SeletorAssessorContasContainer',
  }
);

export const useItemStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
      },
      primary: {
        whiteSpace: 'nowrap', 
        width: '68%',
        // overflow: 'hidden',
        // textOverflow: 'ellipsis', 
        display: 'flex',
        justifyContent: 'center',
        justifyItems: 'centen',
        alignItems: 'center',
        fontSize: 13,
        fontWeight: 600,
        height:60,
        paddingRight: 8,
        borderRight: `1px solid ${sicrediStyles.secondarySicrediLight}`,
        marginRight: 16,
        color: sicrediStyles.secondarySicrediDark,
        [theme.breakpoints.width("sm")]: {
          width: '40%',
        }
      },
      secondary: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: 400,
        color: '#333333',
        whiteSpace: 'pre'
      },
      circleChecked: {
        marginRight: '15px',
        color: sicrediStyles.primarySicredi
      }
    }),
  {
    name: 'SeletorAssessorContasItem',
  }
);

export const useHeadertyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
        width: '100%',
        backgroundColor: '#F8F9F7',
      },
      text: {
        fontFamily: '"Exo 2"',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 600,
        height: 32,
        color: sicrediStyles.secondarySicrediDarker,
        [theme.breakpoints.down("sm")]: {
          fontSize: 14,
        }
      },
      textPresença: {
        fontFamily: '"Exo 2"',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 600,
        height: 32,
        color: sicrediStyles.secondarySicrediDarker,
        textAlign: 'center',
        [theme.breakpoints.down("sm")]: {
          fontSize: 14,
        }
      },
      noContent: {
        fontFamily: '"Exo 2"',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 600,
        height: 32,
        color: sicrediStyles.secondarySicrediDarker,
        [theme.breakpoints.down("sm")]: {
          fontSize: 14,
        },
        textAlign: 'center'
      },
      switchAceiteRow: {
        flexWrap: 'wrap',
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
      },
      legendaText: {
        fontSize: '14px',
        fontWeight: 'bold',
        whiteSpace: 'pre-wrap',
        lineHeight: '20px',
        marginBottom: '5px',
        marginRight: '20px',
        '&:last-child': {
          marginRight: '0px',
        },
      },
      legendaIcon: {
        fontSize: '16px',
        marginRight: '10px',
        color: sicrediStyles.primarySicredi,
        verticalAlign: 'center',
      },
      tableIcon: {
        width: '16px !important',
        height: '16px !important',
        marginRight: '10px',
        color: sicrediStyles.primarySicredi
      },
    }),
  {
    name: 'SeletorAssessorContasHeader',
  }
);
